module.exports = __webpack_public_path__ + "media/mpsp.ae0e3261.mp4";